<template>
  <div class="wrp">
    <InvitationPage
      :InvitationPageInfo="InvitationPageInfo"
      :leadSn="leadSn"
      :tutorChatToken="tutorChatToken"
    ></InvitationPage>
  </div>
</template>

<script>
import InvitationPage from "../components/Main/InvitationPage";
import { LeadHandler } from "@/handler/LeadHandler.js";
export default {
  components: {
    InvitationPage
  },
  data() {
    return {
      leadSn: "",
      tutorChatToken: "",
      ProviderId: "",
      InvitationPageInfo: {
        LeadSn: "",
        SocialNetWorkProviderId: "",
        ProviderName: "",
        QRCodeLink: "",
        Code: "",
        PhoneNumber: "",
        PhoneNumberMask: "",
        AttorneyPhone: "",
        AttorneyPhoneMask: "",
        OtherPhone: "",
        OtherPhoneMask: ""
      }
    };
  },
  created() {
    document.title = "專屬邀請頁";
    this.leadSn = this.$route.query.ls;
    this.tutorChatToken = this.$route.query.tct;
    this.ProviderId = this.$route.query.pid;
    this.InvitationPageInfo = LeadHandler.getInvitationPageInfo(
      this.leadSn,
      this.tutorChatToken,
      this.ProviderId
    );
  },
  methods: {}
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/MobileInvitationPageView.vue